import { useDisclosure } from '@mantine/hooks'
import React from 'react'

type PopoverContext = {
  opened: boolean
  openPopover: () => void
  closePopover: () => void
  togglePopover: () => void
}

export const PopoverContext = React.createContext<PopoverContext>(
  {} as PopoverContext
)

export default function PopoverProvider({ children }: React.PropsWithChildren) {
  const [opened, { open, close, toggle }] = useDisclosure(false)

  return (
    <PopoverContext.Provider
      value={{
        opened,
        openPopover: open,
        closePopover: close,
        togglePopover: toggle,
      }}
    >
      {children}
    </PopoverContext.Provider>
  )
}

export const usePopoverContext = () => React.useContext(PopoverContext)
